/**
 * Lab module layout with sub-navigation.
 * Provides consistent navigation for all Lab pages.
 */
import { ReactNode } from 'react';
import { useLocation } from 'wouter';
import { cn } from '@/lib/utils';

interface LabLayoutProps {
  children: ReactNode;
}

const LAB_NAV_ITEMS = [
  { href: '/lab/batches', label: '批次追溯' },
  { href: '/lab/qc', label: '质检单' },
  { href: '/lab/release', label: '放行单' },
  { href: '/lab/infusion', label: '输液单' },
  { href: '/lab/exceptions', label: '异常事件' },
  { href: '/lab/sample-records', label: '样本记录' },
];

export default function LabLayout({ children }: LabLayoutProps) {
  const [location] = useLocation();

  return (
    <div className="flex flex-col gap-6">
      {/* Lab sub-navigation */}
      <div className="border-b border-border">
        <nav className="flex gap-8 px-6 py-3">
          {LAB_NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={cn(
                'text-sm font-medium transition-colors',
                location.startsWith(item.href)
                  ? 'border-b-2 border-primary text-primary pb-3'
                  : 'text-muted-foreground hover:text-foreground pb-3'
              )}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>

      {/* Content area */}
      <div className="px-6">{children}</div>
    </div>
  );
}
